import { combineReducers } from 'redux';
import messenger from './messenger/reducer';

const reducers = combineReducers({
  messenger
});

export default reducers;
